import { AUTH_TYPES } from '../actions/types';

const initialState = {
    user: null,
    isLogged: false,
    isLoading: false,
    isStore: false,
    errors: null,
    isFetching: null,
    currency: null,
}

export default function authReducers(state = initialState, action) {
    switch (action.type) {

        case AUTH_TYPES.AUTH_REQUEST:
            return {
                ...state,
                isLoading: true,
            };

        case AUTH_TYPES.AUTH_FAILURE:
            return {
                ...state,
                isLoading: false,
                errors: action.payload,
            };

        case AUTH_TYPES.USER_IS_FETCHING:
            return {
                ...state,
                isFetching: action.payload
            };


        case AUTH_TYPES.LOGIN_REQUEST:
            return {
                ...state,
                isLogged: false,
                isLoading: true,
                user: null
            };
        case AUTH_TYPES.LOGIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isLogged: true,
                errors: null,
                user: action.payload,
            };
        case AUTH_TYPES.LOGIN_FAILURE:
            return {
                ...state,
                isLoading: false,
                isLogged: false,
                errors: action.payload,
                user: null
            };
        case AUTH_TYPES.LOGIN_STORE_REQUEST:
            return {
                ...state,
                isLogged: false,
                isLoading: true,
                isStore: false,
                user: null
            };
        case AUTH_TYPES.LOGIN_STORE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isLogged: true,
                isStore: true,
                errors: null,
                user: action.payload
            };
        case AUTH_TYPES.LOGIN_STORE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isLogged: false,
                isStore: false,
                errors: action.payload,
                user: null
            };

        case AUTH_TYPES.LOGOUT_SUCCESS:
            return {
                user: null,
                isLogged: false,
                isLoading: false,
                isStore: false,
                isFetching: null,
                errors: null
            };

        case AUTH_TYPES.LOGIN_FORGOT_PASSWORD_REQUEST_SUCCESS:
            return {
                ...state,
                user: action.payload,
                isLoading: false,
                errors: null
            };


        case AUTH_TYPES.LOGIN_RESET_PASSWORD_REQUEST_SUCCESS:
            return {
                ...state,
                user: action.payload,
                isLoading: false,
                errors: null
            };
        case AUTH_TYPES.CLEAN_ERRORS:
            return {
                ...state,
                errors: null
            }
        case AUTH_TYPES.CHANGE_PROFILE:
            return {
                ...state,
                user: {
                    ...state.user,
                    firstname: action.payload.firstname,
                    lastname: action.payload.lastname,
                    updated: true,
                }
            }
        // HO-ISSUE-119: refresca las propiedades vinculadas con lo que
        // devuelve el backend. La lista se guardaba en el login y no se volvia
        // a pedir, asi que despues de renombrar un inmueble -- desde "Mi
        // perfil" o desde el administrador -- el selector "Cambiar de
        // propiedad" seguia mostrando el nombre viejo. Tampoco se enteraba de
        // una unidad recien vinculada o desvinculada hasta cerrar sesion.
        case AUTH_TYPES.UPDATE_MY_PROPERTIES:
            return {
                ...state,
                user: {
                    ...state.user,
                    properties: action.payload.properties,
                    hasMultipleProperties: action.payload.hasMultipleProperties,
                }
            }
        case AUTH_TYPES.SET_CURRENCY:
            return {
                ...state,
                currency: action.payload
            }
        default:
            return state;
    }
}